import "jquery"
const fullpage: (string, option) => any = require("../lib/fullpage/index")
import "../lib/fullpage/index.css"
import { isMobile } from "./misc"

interface FullpageSection {
	anchor: null,
	index: number,
	isFirst: boolean,
	isLast: boolean,
	item: HTMLDivElement
}

const cvSectionNav = $(".cv-section-nav")

const setCurrentNavIdx = (idx: number) => {
	if (idx === 0) {
		if (cvSectionNav.hasClass("show")) {
			cvSectionNav.removeClass("show")
		}
		cvSectionNav.attr("data-active-index", 0)
	} else {
		if (!cvSectionNav.hasClass("show")) {
			cvSectionNav.addClass("show")
		}
		cvSectionNav.attr("data-active-index", idx)
	}
}

export default () => {
	const player = fullpage(".page-sections", {
		afterLoad: (origin: FullpageSection | null, destination: FullpageSection, direction) => {
			const section = destination.item
			if (!section.classList.contains("entered")) {
				section.classList.add("entered")
			}

			if (!section.classList.contains("cv-section")) {
				cvSectionNav.removeClass("visible")
			}
		},
		onLeave: !isMobile() ? (origin: FullpageSection, destination: FullpageSection, direction) => {
			const section = destination.item
			if (section.classList.contains("cv-section")) {
				cvSectionNav.addClass("visible")
			}

			const index = section.id.startsWith("cv-section-") ? parseInt(section.id.substr(11)) : 0;
			setCurrentNavIdx(index)
		}: null
	})

	cvSectionNav.on("click", (event) => {
		player.moveTo($(event.target).index() + 1);
	})
}